import { useEffect, useState } from 'react';

type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  accent?: boolean;
};

export default function SectionHeading({ kicker, title, desc, accent = false }: SectionHeadingProps) {
  return (
    <div className="mb-6 md:mb-8">
      <p className="flex items-center gap-2 text-xs tracking-[0.3em] text-[#b0392a] font-semibold">
        <span className={`inline-block h-2 w-2 rounded-full ${accent ? 'bg-[#c83424]' : 'bg-[#e0a01a]'}`}></span>
        {kicker}
      </p>
      <h2 className="font-display rule-accent inline-block mt-3 text-2xl md:text-4xl font-extrabold text-[#262019]">
        {title}
      </h2>
      {desc && <p className="mt-4 max-w-3xl text-sm md:text-base leading-relaxed text-[#6b5f51]">{desc}</p>}
    </div>
  );
}